
const $ = window.jQuery;
export default {
  attach: function (context, settings) {
    // Don't forget to modify the redirect logic in page template when you modify this file.
    // @see /templates/system/page--protected-file-access-check.html.twig

    // Local storage expires after 15 minutes.
    let expired = true;
    let time = Date.now();
    let expiry = localStorage.getItem('protected-content-expiry');
    if (expiry) {
      expired = (time > expiry);
    }
    if (expired) {
      localStorage.removeItem('protected-content-expiry');
      localStorage.removeItem('protected-content-accepted-ids');
    }
    else {
      Drupal.behaviors.protectedContent.expiryUpdate(time);
    }

    // Check if block ids exist in local storage.
    let data = localStorage.getItem('protected-content-accepted-ids');
    if (typeof settings.urifm_theme !== 'undefined') {
      let storedIds = [];
      let blockId = settings.urifm_theme.protected_content.block_id;
      if (data) {
        storedIds = JSON.parse(data);
        // Show popup if the current block has not been accepted yet.
        if (storedIds.indexOf(blockId) == -1) {
          Drupal.behaviors.protectedContent.showPopup(blockId, storedIds, time);
        }
        // Lazy load protected media if the popup has already been accepted.
        else {
          Drupal.behaviors.protectedContent.lazyLoadProtectedMedia();
        }
      } else {
        Drupal.behaviors.protectedContent.showPopup(blockId, storedIds, time);
      }
    }
  },
  expiryUpdate: function(time) {
    // Local storage expires after 15 minutes.
    localStorage.setItem('protected-content-expiry', JSON.stringify(time + 15 * 60 * 1000));
  },
  showPopup: function (blockId, storedIds, time) {
    $('.protected-content.overlay').removeClass('visually-hidden');
    $('.protected-content.popup').removeClass('visually-hidden');
    // Cancel: Navigate to the homepage.
    $('.protected-content.popup .cancel').on("click", function () {
      location.href = Drupal.url('');
    });
    // Ok: Set local storage variable, close popup.
    $('.protected-content.popup .accept').on("click", function () {
      storedIds.push(blockId);
      localStorage.setItem('protected-content-accepted-ids', JSON.stringify(storedIds));
      Drupal.behaviors.protectedContent.expiryUpdate(time);
      $('.protected-content.overlay').addClass('visually-hidden');
      $('.protected-content.popup').addClass('visually-hidden');
      Drupal.behaviors.protectedContent.lazyLoadProtectedMedia();
    });
  },
  lazyLoadProtectedMedia: function () {
    // Lazy-loading protected document link.
    $('a[data-href]:not([href])').each(function(index, element){
      $(element).attr('href', $(element).attr('data-href'));
      $(element).removeAttr('data-href');
    });
    // Lazy-loading protected audio/video files.
    $('source[data-src]:not([src])').each(function(index, element){
      $(element).attr('src', $(element).attr('data-src'));
      $(element).removeAttr('data-src');
    });
  }
}
